var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconShareExport4K = function SvgIconShareExport4K(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.472 11.125v.037h2.285v-3.79h-.078a59 59 0 0 0-2.207 3.753"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 2.5A2.5 2.5 0 0 0 0 5v10a2.5 2.5 0 0 0 2.5 2.5h15A2.5 2.5 0 0 0 20 15V5a2.5 2.5 0 0 0-2.5-2.5zm2.965 4.644.544-.893h2.137v4.913h.916v1.196h-.916v1.39h-1.39v-1.39H3.125v-1.214C3.842 9.8 4.656 8.47 5.465 7.144m9.663-.893h1.632l-2.675 3.23 2.79 4.269H15.09l-2.099-3.28-.768.875v2.405h-1.485V6.251h1.483V9.61h.072z"
  })));
};
export default SvgIconShareExport4K;